module.exports = __webpack_public_path__ + "app/img/bgWhyUs.b11c5a18.jpg";